var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CloudOffIconSvg from './cloud-off.icon.svg';
export const CloudOffIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: CloudOffIconSvg }));
_react_refresh_temp_1 = CloudOffIcon;
$RefreshReg$(_react_refresh_temp_1, "CloudOffIcon");
